var de_AT = {};
module['exports'] = de_AT;
de_AT.title = "German (Austria)";
de_AT.address = require("./address");
de_AT.company = require("./company");
de_AT.internet = require("./internet");
de_AT.name = require("./name");
de_AT.phone_number = require("./phone_number");
de_AT.cell_phone = require("./cell_phone");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/index.js
// module id = 864
// module chunks = 0